import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { InputDisplay } from '@shared/ui/inputs';
import { OfficerDetailFacade } from '@intrensic/shared/officer-details';
import { Subject, take, takeUntil } from 'rxjs';

@Component({
    selector: 'sh-shared-layout-change-profile-dialog',
    templateUrl: './change-profile-dialog.component.html',
    styleUrls: ['./change-profile-dialog.component.css'],
    standalone: false
})
export class ChangeProfileDialogComponent implements OnInit, OnDestroy {
  public parentFormGroup = new FormGroup({ toggleChangeProfileForm: new FormControl() });
  inputFieldDisplay = InputDisplay.InlineSpaced;
  private ngUnsubscribe = new Subject<void>();

  constructor(private officerDetailFacade: OfficerDetailFacade) {}

  onSaveClick(): void {
    if (this.parentFormGroup.get('toggleChangeProfileForm')?.value) {
      this.officerDetailFacade.updateOfficerFilters(true);
    } else {
      this.officerDetailFacade.updateOfficerFilters(false);
    }
  }

  ngOnInit(): void {
    this.officerDetailFacade
      .getLoggedInOfficer()
      .pipe(take(1), takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        this.parentFormGroup.get('toggleChangeProfileForm')?.setValue(x.autoClearFilters);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
